.caption {
  margin-bottom: 16px;
}
